import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import '../css/facebook-button.css';
import { formatMessage } from '../lib/intl';

class FacebookButton extends Component {
  constructor(props) {
    super(props);
    this.facebookConnect = this.facebookConnect.bind(this);
  }

  facebookConnect() {
    const { FB } = window;
    const { authentication } = this.props;
    const i18n = defineMessages({
      errorSigninUp: {
        id: 'facebookButton.errors.signup',
        defaultMessage: 'Error signing up with Facebook. Try logging in instead.',
      },
    });

    FB.login((auth) => {
      if (auth.status === 'connected') {
        FB.api('/me', (me) => {
          const params = {
            uid: me.id,
            accessToken: auth.authResponse.accessToken,
          };
          this.props.connectWithFacebook(params, authentication)
            .then(({ payload }) => this.props.onConnect(payload))
            .catch(() => alert(formatMessage(this.props.intl)(i18n.errorSigninUp)));
        });
      }
    }, {
        scope: 'public_profile,email',
      });
  }

  renderButton() {
    return (
      <button
        type="button"
        className={`btn btn-facebook btn-block ${this.props.className}`}
        onClick={this.facebookConnect}
      >
        <i className="fa fa-fw fa-facebook" aria-hidden="true" />
        {this.props.children}
      </button>
    );
  }

  renderLink() {
    return (
      <button
        type="button"
        className={`btn-link ${this.props.className}`}
        onClick={this.facebookConnect}
      >
        {this.props.children}
      </button>
    );
  }

  render() {
    if (this.props.asLink) return this.renderLink();
    return this.renderButton();
  }
}

FacebookButton.defaultProps = {
  onConnect: () => { },
  asLink: false,
  authentication: null,
};

export default injectIntl(FacebookButton);



// WEBPACK FOOTER //
// ./src/desktop/components/facebook-button.js